// Storage access throws when the document is denied it (third-party context, blocked cookies) and stored
// JSON can be corrupt: reads fall back to the initial value and writes are best effort, so neither stops boot.
import { createEffect, type Accessor } from 'solid-js'
import { createStore, type SetStoreFunction, type Store } from 'solid-js/store'

const readStored = <T,>(key: string): T | undefined => {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : undefined
  } catch {
    return undefined
  }
}

export function createLocalStore<T extends object>(
  key: string,
  initialValue: T
): [Accessor<Store<T>>, SetStoreFunction<T>] {
  const [state, setState] = createStore<T>(readStored<T>(key) ?? initialValue)

  createEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state))
    } catch {}
  })

  return [() => state, setState]
}
